<div class="ws-product-card__footer">
  @if (cake.image) {
    <div class="ws-product-card__footer-main">
      <div class="ws-product-card__title">
        <a class="ws-product-card__title-link"
           [routerLink]="builderLink"
           [queryParams]="builderLinkQueryParams"
           (click)="$event.preventDefault(); onCakeNameClick.emit()">
          <strong class="ws-product-card__title-text">{{ cake.name }}</strong>
        </a>
      </div>

      @if (isPriceVisible) {
        <div class="ws-product-card__price">
          <cake-item-price
            [currency]="currency"
            [pieces]="cake.pieces"
            [isDifferentPrices]="cake.minPrice !== cake.maxPrice"
            [perUnitText]="('cakeBuilder.sizeUnits.unitType.' + cake.sizeUnit) | translate"
            [price]="cake.minPrice"
            [discount]="cake.discount?.value"
          ></cake-item-price>
        </div>
      }
    </div>
  }

  @if (showBakeryLine) {
    <div class="ws-product-card__meta">
      <div class="ws-product-card__bakery">
        <a class="text-muted" [routerLink]="bakeryOverviewUrl">{{ cake.bakery.name }}</a>
      </div>

      <div class="text-end position-relative">
        @if (isPickUpOnly) {
          <ng-container *ngTemplateOutlet="pickupLine"></ng-container>
        }

        @if (isDeliveryOnly) {
          <ng-container *ngTemplateOutlet="deliveryLine"></ng-container>
        }

        @if (isPickUpAndDelivery) {
          <div class="d-flex nowrap">
            <ng-container *ngTemplateOutlet="pickupLine"></ng-container>
            <div class="mx-1">{{ 'common.or' | translate }}</div>
            <ng-container *ngTemplateOutlet="deliveryLine"></ng-container>
          </div>
        }
      </div>
    </div>
  }
</div>

<ng-template #pickupLine>
  <div class="text-underline pointer ws-product-card__delivery-link"
       (click)="showPickup()">
    {{ 'orderProcess.cakesOverview.cakeItem.pickupPoints' | translate: { count: cake.outletsCount } }}
  </div>
</ng-template>

<ng-template #deliveryLine>
  @if (!isThirdPartyAvailable) {
    <div class="text-underline pointer ws-product-card__delivery-link"
         [class.first-letter-capitalize]="isDeliveryOnly"
         (click)="showDelivery()">
      {{ 'orderProcess.cakesOverview.cakeItem.getDelivery' | translate }}
    </div>
  }

  @if (isThirdPartyAvailable) {
    <div [class.first-letter-capitalize]="isDeliveryOnly">
      {{ 'orderProcess.cakesOverview.cakeItem.getDelivery' | translate }}
    </div>
  }
</ng-template>
